import Smartphones from 'Projects/views/ProjectsImportView/containers/Smartphones'
import Tablets from 'Projects/views/ProjectsImportView/containers/Tablets'

import {getCurrentDeviceView} from 'shared/helpers/utils'

const ProjectsImportView = getCurrentDeviceView(Smartphones, Tablets)

export default ProjectsImportView
